// extracted by mini-css-extract-plugin
module.exports = {"commentForm":"CommentForm_commentForm__3HYHp"};